import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { Nullable } from '@ps/utils';
import { User } from '@ps/auth-data-access';
import {
  BillingRuleRecord,
  DashboardPreference,
  DashboardPreferenceParams,
  ReportPreference,
} from '@ps/user-settings-models';

import { AllBuyerSettings, CompanySettings } from '../models/settings.model';
import { FeatureEntitlement } from '../models/entitlement.model';
import { PersistUserSettings } from '../models/user-settings-persist.model';
import { CurrencySettings } from '../models/currency-settings.model';

export const UserSettingsActions = createActionGroup({
  source: 'User Settings',
  events: {
    Load: props<{ user: User }>(),
    'Load Success': props<{
      allBuyerSettings: AllBuyerSettings;
      companySettings: Nullable<CompanySettings>;
      currencySettings: Nullable<CurrencySettings>;
      entitlements: FeatureEntitlement[];
    }>(),
    'Load Failure': props<{ error: string }>(),
    Rehydrate: props<PersistUserSettings>(),
    'Load Service Operator Settings': props<{
      companyId: number;
      hasImpersonatedBuyer: boolean;
    }>(),
    'Load Service Operator Settings Success': props<{
      companySettings: Nullable<CompanySettings>;
      currencySettings: CurrencySettings;
      companyId: number;
      hasImpersonatedBuyer: boolean;
    }>(),
    'Load Service Operator Settings Failure': props<{
      error: string;
      companyId: number;
      hasImpersonatedBuyer: boolean;
    }>(),
  },
});

export const DashboardActions = createActionGroup({
  source: 'Dashboard',
  events: {
    'Load Preferences': props<{ params: DashboardPreferenceParams }>(),
    'Invalidate Cache': emptyProps(),
  },
});

export const DashboardApiActions = createActionGroup({
  source: 'Dashboard API',
  events: {
    'Load Preferences Success': props<{
      preferences: DashboardPreference[];
      cachedAt: number;
    }>(),
    'Load Preferences Failure': props<{ error: string }>(),
    'Update Preferences': props<{ preferences: DashboardPreference[] }>(),
    'Update Success': emptyProps(),
    'Update Failure': props<{ error: string }>(),
  },
});

export const ReportPreferenceActions = createActionGroup({
  source: 'Report Preference',
  events: {
    'Load Report Preference': props<{ userId: number }>(),
    'Save Report Preference': props<{
      userId: number;
      preferences: ReportPreference[];
    }>(),
  },
});

export const ReportPreferenceApiActions = createActionGroup({
  source: 'Report Preference API',
  events: {
    'Load Report Preference Success': props<{
      preferences: ReportPreference[];
      cachedAt: number;
    }>(),
    'Load Report Preference Failure': props<{ error: string }>(),
    'Save Report Preference Success': emptyProps(),
    'Save Report Preference Failure': props<{ error: string }>(),
  },
});

export const BillingRulesActions = createActionGroup({
  source: 'Billing Rules',
  events: {
    'Load Billing Rules': props<{ selectedBuyerId: Nullable<number> }>(),
  },
});

export const BillingRulesApiActions = createActionGroup({
  source: 'Billing Rules API',
  events: {
    'Load Billing Rules Success': props<{
      record: Nullable<BillingRuleRecord>;
      cachedAt: Nullable<number>;
    }>(),
    'Load Billing Rules Failure': emptyProps(),
  },
});
